import { Icon, Text } from "@certn/cascadia-react";
import { useFutureTimeDifference } from "@certn/utils";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { useCardStyles } from "./styles";

type ExpirationBarProps = {
  expirationDate: Date;
};

export function ExpirationBar({ expirationDate }: ExpirationBarProps) {
  const styles = useCardStyles();
  const { text, days } = useFutureTimeDifference(expirationDate);
  const expiresToday = days < 1;

  return (
    <div
      className={css(
        styles.expirationBar,
        css({
          background: expiresToday
            ? "var(--background-danger-strong)"
            : "var(--background-accent-purple-strong)",
        })
      )}
    >
      <Icon
        name="pace"
        color={expiresToday ? "icon-inverse" : "icon-inverse"}
        type="standard"
        padding="space-1-5"
      />
      <Text
        style="global/heading-small"
        color={expiresToday ? "text-inverse" : "icon-inverse"}
      >
        <Trans>Expires</Trans> {text}
      </Text>
    </div>
  );
}
